const ethereum = require("./ethereum");
const avalanche = require("./avalanche");
const harmony = require("./harmony");
const arbitrum = require("./arbitrum");
const moonbeam = require("./moonbeam");
const moonriver = require("./moonriver");
const polygon = require("./polygon");
const telos = require("./telos");
const fuse = require("./fuse");
const xdai = require("./xdai");
const celo = require("./celo");

const { BigNumber } = require("ethers");
const MAX_AMOUNT = BigNumber.from(2).pow(256).sub(1);

const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";

const CHAINID_TO_NETWORK_NAME = {
  1: "ethereum",
  43114: "avalanche",
  42220: "celo",
  137: "polygon",
  1666600000: "harmony",
  42161: "arbitrum",
  1284: "moonbeam",
  122: "fuse",
  40: "telos",
  1285: "moonriver",
  100: "xdai"
};

const FARM_VERSION_TO_CONTRACT_NAME = {
  masterchefv1: "StrategyMasterChefV1",
  masterchefv2: "StrategyMasterChefV2",
};

const MAP_NETWORK_TO_RPC = {
  ethereum: process.env.ETHEREUM_RPC_URL || "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
  polygon: process.env.POLYGON_RPC_URL || "https://polygon-rpc.com",
  celo: process.env.CELO_RPC_URL || "https://forno.celo.org",
  bsc: process.env.BSC_RPC_URL || "https://bsc-dataseed.binance.org",
  fuse: process.env.FUSE_RPC_URL || "https://rpc.fuse.io",
};

module.exports = {
  ethereum,
  celo,
  arbitrum,
  moonbeam,
  moonriver,
  telos,
  fuse,
  xdai,
  harmony,
  polygon,
  avalanche,
  MAX_AMOUNT,
  ADDRESS_ZERO,
  CHAINID_TO_NETWORK_NAME,
  FARM_VERSION_TO_CONTRACT_NAME,
  MAP_NETWORK_TO_RPC
};
